/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         22/05/24 - 19:19:55
 * Module name:  user-customer.interface
 * File name:    user-customer.interface.ts
 * IDE:          WebStorm
 */

import {CoreMkadStatusEnum} from '@shared/interface/settings/device/customer-device/customer-device.interface';
import {CustomerLevelEnum, CustomerResumeInterface} from '@shared/interface';
import {NO_INDEX_FIND} from '@shared/constants';

export interface UserCustomerDataInterface {
  customer_id: number | null;
  customer_name: string | null;
  customer_initials: string | null;
  customer_logo: string | null;
  customer_level: CustomerLevelEnum;
  allow_public_devs: boolean;
  allow_customers: boolean;
  contract_status: CoreMkadStatusEnum | null;
  contract_end_at: string | null;
  contract_status_message: string | null;
}


export const defaultData: CustomerResumeInterface = {
  id: NO_INDEX_FIND,
  name: '',
};
